export const course = {
    "course_title_Courses": "Courses",
    "course_title_my_a_tutors": "My Available Tutors",
    "course_title_Manager": "Manager",
    "course_table_col_Grade": "Grade",
    "course_table_col_Term": "Term",
    "course_table_col_Name": "Name",
    "course_table_col_Location": "Location",
    "course_table_col_Subject": "Subject",
    "course_table_col_WeekDay": "WeekDay",
    "course_table_col_Time": "Time",
    "course_table_col_Option": "Option",
    "course_table_col_Option_tip": "This setting is used to confirm whether it is effective, but the marked available tutors cannot be delete",
    "course_table_col_Enable": "Enable",
    "course_table_col_Enable_tip": "This setting is used to confirm whether it is effective, but the marked available tutors cannot be modified",
    "course_Create_Course": "Create Course",
    "course_create_modal_title_edit": "Edit Available Tutors",
    "course_create_modal_title_create": "Create Available Tutors",
    "course_create_modal_col_location": "Course Location",
    "course_create_modal_col_Location_tip": "Please select location",
    "course_create_modal_col_WeekDay": "WeekDay",
    "course_create_modal_col_WeekDay_tip": "Please select day of week",
    "course_create_modal_col_Subject": "Subject",
    "course_create_modal_col_Subject_tip": "Please Select Subject",
    "course_create_modal_col_Grade": "Grade",
    "course_create_modal_col_Grade_tip": "Please select grade",
    "course_create_modal_col_Term": "Term",
    "course_create_modal_col_Term_tip": "Please Select Term",
    "course_create_modal_col_TimePeriod": "Time Period",
    "course_create_modal_col_Time_tip": "Click to select the time period you want to exclude",
    "course_manager_tab_search": "Search Available Tutors",
    "course_manager_tab_marked": "Marked Course",
    "course_manager_details_tip_alert": "You can click on a row to view detailed available time periods.",
};
